// src/components/Dashboard.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/main.css';

const Dashboard = () => {
  const navigate = useNavigate();

  // ✅ Guard: si no hay token, mandar al login
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login'); // cambia a '/login' si tu login está en otra ruta
    }
  }, [navigate]);

  // Función de navegación mejorada
  const navigateTo = (dest) => {
    if (dest.startsWith('http') || dest.startsWith('https') || dest.startsWith('anydesk://')) {
      window.open(dest, '_blank');
    } else {
      navigate(dest);
    }
  };

  // ====== Modal de Bancos ======
  const [banksOpen, setBanksOpen] = useState(false);

  // ====== Modal de Tipo de Pedido ======
  const [orderTypeOpen, setOrderTypeOpen] = useState(false);

  const banks = [
    {
      key: 'nacional',
      name: 'Nacional',
      icon: 'https://floristeria2000.com/wp-content/uploads/2026/01/nacional.webp',
      url: 'https://auth.bncr.fi.cr/',
    },
    {
      key: 'credomatic',
      name: 'Credomatic',
      icon: 'https://floristeria2000.com/wp-content/uploads/2026/01/bac.webp',
      url: 'https://www.sucursalelectronica.com/redir/showLogin.go',
    },
    {
      key: 'davivienda',
      name: 'Davivienda',
      icon: 'https://floristeria2000.com/wp-content/uploads/2026/01/davivienda.webp',
      url: 'https://enlinea.davivienda.cr/',
    },
    {
      key: 'credix',
      name: 'Credix',
      icon: 'https://floristeria2000.com/wp-content/uploads/2026/01/credix.webp',
      url: 'https://micredix.com/',
    },
    {
      key: 'popular',
      name: 'Popular',
      icon: 'https://floristeria2000.com/wp-content/uploads/2026/01/popular.webp',
      url: 'https://canalvirtual.bancopopular.fi.cr/Persona',
    },
    {
      key: 'costarica',
      name: 'Costa Rica',
      icon: 'https://floristeria2000.com/wp-content/uploads/2026/01/costa-rica.webp',
      url: 'https://www.personas.bancobcr.com/',
    },
  ];

  const openBank = (bank) => {
    if (bank?.url) navigateTo(bank.url);
  };

  // Cerrar modal con Escape
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        setBanksOpen(false);
        setOrderTypeOpen(false);
      }
    };

    if (banksOpen || orderTypeOpen) window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [banksOpen, orderTypeOpen]);

  const goOrderFull = () => {
    setOrderTypeOpen(false);
    navigateTo('/register-order');
  };

  const goOrderSimple = () => {
    setOrderTypeOpen(false);
    navigateTo('/register-window-order');
  };

  return (
    <div className="dashboard-content">
      <header className="dash-header">
        <h1>Dashboard</h1>
        <p>Bienvenido/a</p>
      </header>

      <section className="dash-section">
        <h2>Registro de Pedidos</h2>

        <div className="dash-buttons-grid">
          {/* ✅ Abre popup para elegir tipo de pedido */}
          <div className="dash-button-card" onClick={() => setOrderTypeOpen(true)}>
            <img
              src="https://floristeria2000.com/wp-content/uploads/2025/12/registrar-nuevo-pedido.png"
              alt="Registrar Pedido"
              className="dash-button-icon"
            />
            <h3>Registrar Nuevo Pedido</h3>

            <button
              onClick={(e) => {
                e.stopPropagation();
                setOrderTypeOpen(true);
              }}
            >
              Ir
            </button>
          </div>

          <div className="dash-button-card" onClick={() => navigateTo('/orders')}>
            <img
              src="https://floristeria2000.com/wp-content/uploads/2025/12/ver-pedidos-activos.png"
              alt="Pedidos"
              className="dash-button-icon"
            />
            <h3>Ver Pedidos Activos</h3>
            <button onClick={(e) => { e.stopPropagation(); navigateTo('/orders'); }}>Ir</button>
          </div>

          <div className="dash-button-card" onClick={() => navigateTo('/notes')}>
            <img
              src="https://floristeria2000.com/wp-content/uploads/2025/12/notas.png"
              alt="Notas"
              className="dash-button-icon"
            />
            <h3>Ver Notas</h3>
            <button onClick={(e) => { e.stopPropagation(); navigateTo('/notes'); }}>Ir</button>
          </div>
        </div>
      </section>

      <section className="dash-section">
        <h2>Administración De Cuentas</h2>

        <div className="dash-buttons-grid">
          <div className="dash-button-card" onClick={() => navigateTo('/accounts-receivable')}>
            <img
              src="https://floristeria2000.com/wp-content/uploads/2025/12/por-cobrar.png"
              alt="CPC"
              className="dash-button-icon"
            />
            <h3>Cuentas por Cobrar</h3>
            <button onClick={(e) => { e.stopPropagation(); navigateTo('/accounts-receivable'); }}>Ir</button>
          </div>

          <div className="dash-button-card" onClick={() => navigateTo('/AccountsPayable')}>
            <img
              src="https://floristeria2000.com/wp-content/uploads/2025/12/por-pagar.png"
              alt="CPP"
              className="dash-button-icon"
            />
            <h3>Cuentas por Pagar</h3>
            <button onClick={(e) => { e.stopPropagation(); navigateTo('/AccountsPayable'); }}>Ir</button>
          </div>

          <div className="dash-button-card" onClick={() => navigateTo('/payable-bills')}>
            <img
              src="https://floristeria2000.com/wp-content/uploads/2025/12/facturas.png"
              alt="Facturas"
              className="dash-button-icon"
            />
            <h3>Administración de Facturas</h3>
            <button onClick={(e) => { e.stopPropagation(); navigateTo('/payable-bills'); }}>Ir</button>
          </div>

          <div className="dash-button-card" onClick={() => navigateTo('/CierreDeCaja')}>
            <img
              src="https://floristeria2000.com/wp-content/uploads/2025/12/caja.png"
              alt="Cierre de Caja"
              className="dash-button-icon"
            />
            <h3>Cierre De Caja</h3>
            <button onClick={(e) => { e.stopPropagation(); navigateTo('/CierreDeCaja'); }}>Ir</button>
          </div>

          <div className="dash-button-card" onClick={() => navigateTo('/cierre-general')}>
            <img
              src="https://floristeria2000.com/wp-content/uploads/2026/01/historial.webp"
              alt="Cierre General"
              className="dash-button-icon"
            />
            <h3>Cierre General</h3>
            <button onClick={(e) => { e.stopPropagation(); navigateTo('/cierre-general'); }}>Ir</button>
          </div>

          <div className="dash-button-card" onClick={() => setBanksOpen(true)}>
            <img
              src="https://floristeria2000.com/wp-content/uploads/2026/01/bancos.webp"
              alt="Bancos"
              className="dash-button-icon"
            />
            <h3>Bancos</h3>
            <button onClick={(e) => { e.stopPropagation(); setBanksOpen(true); }}>Abrir</button>
          </div>
        </div>
      </section>

      <section className="dash-section">
        <h2>Botones Esenciales</h2>

        <div className="dash-buttons-grid">
          <div className="dash-button-card" onClick={() => navigateTo('https://outlook.live.com/mail/0/')}>
            <img
              src="https://floristeria2000.com/wp-content/uploads/2025/12/correo.png"
              alt="Correo"
              className="dash-button-icon"
            />
            <h3>Correo</h3>
            <button onClick={(e) => { e.stopPropagation(); navigateTo('https://outlook.live.com/mail/0/'); }}>Abrir</button>
          </div>

          <div className="dash-button-card" onClick={() => navigateTo('https://sistema.grupoargus.co.cr/')}>
            <img
              src="https://floristeria2000.com/wp-content/uploads/2025/12/Argus.png"
              alt="Argus"
              className="dash-button-icon"
            />
            <h3>Argus</h3>
            <button onClick={(e) => { e.stopPropagation(); navigateTo('https://sistema.grupoargus.co.cr/'); }}>Abrir</button>
          </div>

          <div className="dash-button-card" onClick={() => navigateTo('https://mercuryhq.com/login')}>
            <img
              src="https://floristeria2000.com/wp-content/uploads/2025/12/mercury.png"
              alt="Mercury"
              className="dash-button-icon"
            />
            <h3>Mercury</h3>
            <button onClick={(e) => { e.stopPropagation(); navigateTo('https://mercuryhq.com/login'); }}>Abrir</button>
          </div>

          <div className="dash-button-card" onClick={() => navigateTo('https://www.floreriaslatinas.com/login/')}>
            <img
              src="https://floristeria2000.com/wp-content/uploads/2025/12/latinas.png"
              alt="Latinas"
              className="dash-button-icon"
            />
            <h3>Latinas</h3>
            <button onClick={(e) => { e.stopPropagation(); navigateTo('https://www.floreriaslatinas.com/login/'); }}>Abrir</button>
          </div>

          <div className="dash-button-card" onClick={() => navigateTo('https://web.whatsapp.com')}>
            <img
              src="https://floristeria2000.com/wp-content/uploads/2025/12/Whatsapp.png"
              alt="WhatsApp"
              className="dash-button-icon"
            />
            <h3>WhatsApp</h3>
            <button onClick={(e) => { e.stopPropagation(); navigateTo('https://web.whatsapp.com'); }}>Abrir</button>
          </div>

          <div className="dash-button-card" onClick={() => navigateTo('https://merchants.ubereats.com/orders/dashboard_v2/orders/new')}>
            <img
              src="https://floristeria2000.com/wp-content/uploads/2026/01/ubereats.webp"
              alt="Uber Eats"
              className="dash-button-icon"
            />
            <h3>Uber Eats</h3>
            <button onClick={(e) => { e.stopPropagation(); navigateTo('https://merchants.ubereats.com/orders/dashboard_v2/orders/new'); }}>Abrir</button>
          </div>
        </div>
      </section>

      {/* =========================
          MODAL: TIPO DE PEDIDO (MISMA ESTÉTICA QUE BANCOS)
      ========================= */}
      {orderTypeOpen && (
        <div className="modal-overlay" onClick={() => setOrderTypeOpen(false)}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setOrderTypeOpen(false)} aria-label="Cerrar">
              ×
            </button>

            <div className="modal-header">
              <h2>REGISTRAR PEDIDO</h2>
              <p>Seleccioná el tipo de pedido</p>
            </div>

            <div className="modal-separator" />

            {/* ✅ Reutilizamos el grid de bancos para que se vea igual */}
            <div className="modal-banks-grid modal-order-grid">
              {/* PEDIDO COMPLETO */}
              <div
                className="dash-button-card modal-bank-card"
                onClick={goOrderFull}
              >
                <span className="pr-icon" role="img" aria-label="Icono de documento">
                  📄
                </span>
                <h3>Pedido Completo</h3>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    goOrderFull();
                  }}
                >
                  Ir
                </button>
              </div>

              {/* PEDIDO SIMPLE */}
              <div
                className="dash-button-card modal-bank-card"
                onClick={goOrderSimple}
              >
                <span className="pr-icon" role="img" aria-label="Icono de caja">
                  📦
                </span>
                <h3>Pedido Simple</h3>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    goOrderSimple();
                  }}
                >
                  Ir
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* =========================
          MODAL: BANCOS
      ========================= */}
      {banksOpen && (
        <div className="modal-overlay" onClick={() => setBanksOpen(false)}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setBanksOpen(false)} aria-label="Cerrar">
              ×
            </button>

            <div className="modal-header">
              <h2>BANCOS</h2>
              <p>Presiona el banco que quieras acceder</p>
            </div>

            <div className="modal-separator" />

            <div className="modal-banks-grid">
              {banks.map((bank) => (
                <div
                  key={bank.key}
                  className="dash-button-card modal-bank-card"
                  onClick={() => openBank(bank)}
                >
                  <img src={bank.icon} alt={bank.name} className="dash-button-icon" />
                  <h3>{bank.name}</h3>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      openBank(bank);
                    }}
                  >
                    Abrir
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
